import type { SVGProps } from 'react';
export const Voucher = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.15 6.11v1.42A2.55 2.55 0 0 1 6.13 10a2.5 2.5 0 0 1-1.98 2.47v1.42h3.44V6.1zM4.07 5q-.46 0-.76.31-.3.32-.31.74v1.53q0 .37.24.66t.61.37A1.4 1.4 0 0 1 4.98 10a1.4 1.4 0 0 1-1.13 1.4q-.37.07-.61.36-.24.3-.24.66v1.53q0 .42.3.74.32.3.77.31h11.86q.45 0 .76-.31.3-.32.31-.74v-1.53q0-.37-.24-.66a1 1 0 0 0-.61-.37A1.4 1.4 0 0 1 15.02 10a1.4 1.4 0 0 1 1.13-1.4q.37-.07.61-.36.24-.3.24-.66V6.05q0-.42-.3-.74-.32-.3-.77-.31zm4.67 1.11v7.78h7.11v-1.42A2.55 2.55 0 0 1 13.87 10a2.5 2.5 0 0 1 1.98-2.47V6.11z"
      clipRule="evenodd"
    />
  </svg>
);
